export class EmployeeInfoModel {
    employee_no: number
    address: string
    city: string
    state: string
    zip: string
    zip4: string
    cellphone: string
    office_phone: string
    email: string
    country: string

    constructor(
        employee_no: number,
        address: string,
        city: string,
        state: string,
        zip: string,
        zip4: string,
        cellphone: string,
        office_phone: string,
        email: string
    ) {
        this.employee_no = employee_no
        this.address = address
        this.city = city
        this.state = state
        this.zip = zip
        this.zip4 = zip4
        this.cellphone = cellphone
        this.office_phone = office_phone
        this.email = email
        this.country = ''
    }
}